<template>
    <div class="overview-reservations">
        <div style="display: flex;margin-bottom: 16px;gap: 40px">
            <div class="toggle-button" v-on:click="onlineOnly=!onlineOnly">
                <img alt="" :src="require('../../../assets/ON-small.svg')" v-if="onlineOnly"/>
                <img alt="" :src="require('../../../assets/OFF-small.svg')" v-else/>
                <div class="label">{{ $t('online_only') }}</div>
            </div>
            <div class="toggle-button" v-on:click="todayOnly=!todayOnly">
                <img alt="" :src="require('../../../assets/ON-small.svg')" v-if="todayOnly"/>
                <img alt="" :src="require('../../../assets/OFF-small.svg')" v-else/>
                <div class="label">{{ $t('today_only') }}</div>
            </div>
        </div>
        <table>
            <tbody>
            <tr v-for="i in data" v-on:click="itemSelected(i.id, i.row)"
                :class="'state_' + i.status">
                <td>{{ i.id }}</td>
                <td>{{ i.full_name }}</td>
                <td>{{ i.room }}</td>
                <td>{{ i.room_count }}/{{ i.guest_count }}</td>
                <td style="text-align: right">
                    <i class="icon icon--person-check-fill" v-if="i.precheckin_complete"/>
                </td>
                <td style="text-align: right">{{ i.checkin_date }} → {{ i.checkout_date }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

import axios from 'axios';
import moment from 'moment';

export default {
    name: 'overview-reservations',
    props: ['all'],
    data() {
        return {
            data: undefined,
            count: undefined,
            onlineOnly: false,
            todayOnly: false
        };
    },
    mounted() {
        this.loadData()
    },
    watch: {
        onlineOnly: function () {
            this.loadData()
        },
        todayOnly: function () {
            this.loadData()
        }
    },
    methods: {
        itemSelected: function (id, row) {
            this.$router.push(`/bookings/edit/${id}/${row}`)
        },
        loadData: function () {
            const now = moment()

            axios({
                data: `{
                listReservations(${!this.all ? `cancelled: false, ` : ''}${this.todayOnly ? `created_at: "${now.format('YYYY-MM-DD')}:${now.add(1, 'd').format('YYYY-MM-DD')}", ` : ''}${this.onlineOnly ? 'online: true, ' : ''}order_by: "id|desc", limit: ${this.all ? 50 : 10})
                {
                    items {
                        id
                        name
                        note
                        is_group
                        created_at
                        not_refundable
                        reservation_rows {
                            id
                            reservation_number
                            check_in_date
                            check_out_date
                            guest_count
                            total_price_per_room
                            room_type_id
                            room_count
                            complete_profiles
                            room_type {
                                code
                            }
                            price_list {
                                accommodation_currency {
                                    code_iso
                                }
                            }
                            guests {
                                profile {
                                    full_name
                                }
                                room {
                                    code
                                }
                            }
                            canceled
                        }
                    },
                    pageInfo {
                        totalCount
                    }
                }
            }`
            }).then(response => {
                this.count = response.data.data.listReservations.pageInfo.totalCount;

                let reservations = [];

                response.data.data.listReservations.items.forEach(function (item) {
                    item.reservation_rows.forEach(function (row) {
                        let reservation = {};
                        reservation.id = item.id;
                        reservation.row = row.id;
                        reservation.room = row.room_type.code;
                        reservation.price = row.total_price_per_room;
                        reservation.create_date = moment(row.create_date).format('D.M.');
                        reservation.checkin_date = moment(row.check_in_date).format('D.M.');
                        reservation.checkout_date = moment(row.check_out_date).format('D.M.YY');
                        reservation.guest_count = row.guest_count;
                        reservation.room_count = row.room_count;
                        reservation.icons = [];
                        reservation.group = item.is_group;
                        reservation.currency = row.price_list.accommodation_currency.code_iso;
                        reservation.full_name = item.name;
                        reservation.room_numbers = [];
                        reservation.precheckin_complete = row.complete_profiles >= row.guest_count

                        if (row.guests[0] && !item.name) {
                            reservation.full_name = row.guests[0].profile.full_name;
                        }

                        if (row.guests) {
                            row.guests.forEach(function (item) {
                                if (item.room) {
                                    reservation.room_numbers.push(item.room.code);
                                }
                            });

                            reservation.room_numbers = [...new Set(reservation.room_numbers)];
                        }

                        if (row.canceled) {
                            reservation.status = 'canceled'
                        } else if (item.not_refundable) {
                            reservation.status = 'not_refundable'
                        } else if (moment(row.check_in_date).isSame(moment(), 'day') &&
                            moment(item.created_at).isSame(moment(), 'day')) {
                            reservation.status = 'today'
                        } else {
                            reservation.status = 'new'
                        }

                        reservations.push(reservation);
                    });
                });

                this.data = reservations;
            }).catch(error => {
                this.showError(error)
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/part/ui/overview-reservations.vue